import router from "../../../router";
import axios from "axios";

export default {
    loadClientList({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['clients/getClientFilterFields'];
            let main_filter = this.getters['clients/getClientMainFilter'];

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setClientFilterFieldsMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.clientNumber && router.currentRoute.query.client_number) {
                filter_fields.clientNumber = router.currentRoute.query.client_number;

                commit('setClientFilterFieldsMutation', {field_name: 'clientNumber', field_value: router.currentRoute.query.client_number})
            }

            if (!filter_fields.clientTitle && router.currentRoute.query.client_title) {
                filter_fields.clientTitle = router.currentRoute.query.client_title;

                commit('setClientFilterFieldsMutation', {field_name: 'clientTitle', field_value: router.currentRoute.query.client_title})
            }

            if (!filter_fields.clientPhoneNumber && router.currentRoute.query.client_phone_number) {
                filter_fields.clientPhoneNumber = router.currentRoute.query.client_phone_number;

                commit('setClientFilterFieldsMutation', {field_name: 'clientPhoneNumber', field_value: router.currentRoute.query.client_phone_number})
            }

            if (!filter_fields.clientDeleted && router.currentRoute.query.client_deleted) {
                filter_fields.clientDeleted = router.currentRoute.query.client_deleted;

                commit('setClientFilterFieldsMutation', {field_name: 'clientDeleted', field_value: router.currentRoute.query.client_deleted})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/client/client-list', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                commit('setClientList', response.data.data.result.clients);
                commit('setClientListCount', response.data.data.result.clients_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    loadClientList2({ commit, dispatch }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['clients/getClientFilterFields'];
            let main_filter = this.getters['clients/getClientMainFilter'];

            if (!payload['preloader_disable'] || payload['preloader_disable'] == false) {
                dispatch('pagePreloader/setPagePreloaderIsActive', true, {root: true});

                commit('setClientList', []);
            }

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setClientFilterFieldsMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.clientNumber && router.currentRoute.query.client_number) {
                filter_fields.clientNumber = router.currentRoute.query.client_number;

                commit('setClientFilterFieldsMutation', {field_name: 'clientNumber', field_value: router.currentRoute.query.client_number})
            }

            if (!filter_fields.clientTitle && router.currentRoute.query.client_title) {
                filter_fields.clientTitle = router.currentRoute.query.client_title;

                commit('setClientFilterFieldsMutation', {field_name: 'clientTitle', field_value: router.currentRoute.query.client_title})
            }

            if (!filter_fields.clientPhoneNumber && router.currentRoute.query.client_phone_number) {
                filter_fields.clientPhoneNumber = router.currentRoute.query.client_phone_number;

                commit('setClientFilterFieldsMutation', {field_name: 'clientPhoneNumber', field_value: router.currentRoute.query.client_phone_number})
            }

            if (!filter_fields.clientDeleted && router.currentRoute.query.client_deleted) {
                filter_fields.clientDeleted = router.currentRoute.query.client_deleted;

                commit('setClientFilterFieldsMutation', {field_name: 'clientDeleted', field_value: router.currentRoute.query.client_deleted})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/client/client-list2', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                dispatch('pagePreloader/setPagePreloaderIsActive', false, {root: true});

                commit('setClientList', response.data.data.result.clients);
                commit('setClientListCount', response.data.data.result.clients_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    setClientFilterFields({ commit }, payload)
    {
        commit('setClientFilterFieldsMutation', payload);
    },
    deleteClients({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            axios.post('/api/client/client-delete-clients', {
                ids: payload
            }).then(response => {
                const result = response.data.data;

                if (response.data.data.result.success !== true) {
                    resolve(false);
                }

                commit('deleteClientsMutation', payload);

                resolve(true);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setClientModalOpen({commit}, payload)
    {
        commit('setClientModalOpenMutation', payload);
    },
    setClientIdAndClientIndexToModalForm({commit}, payload)
    {
        commit('setClientIdAndClientIndexToModalFormMutation', payload);
    },
    addClientToClientList({commit}, payload)
    {
        commit('addClientToClientList', payload);
    },
    updateClient({ commit }, payload)
    {
        commit('updateClient', payload);
    },
}
